import { apiFetch } from '$lib/api/helpers';
import type {
	AdminUser,
	CreateUserRequest,
	LoginEvent,
	UpdateUserRequest,
	UserProfile
} from '$lib/types/user';

const PATH = '/users/';

export async function fetchUsers() {
	return apiFetch<Array<AdminUser>>(PATH);
}

export async function fetchProfile() {
	return apiFetch<UserProfile>(`${PATH}profile/`);
}

export async function createUser(body: CreateUserRequest) {
	return apiFetch<AdminUser>(PATH, { method: 'POST', body: JSON.stringify(body) });
}

export async function updateUser(id: number, body: UpdateUserRequest) {
	return apiFetch<AdminUser>(`${PATH}${id}/`, { method: 'PATCH', body: JSON.stringify(body) });
}

export async function deleteUser(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function fetchLoginEvents(id: number) {
	return apiFetch<Array<LoginEvent>>(`${PATH}${id}/login-events/`);
}
